import type { OverflowToolbarItem } from './OverflowToolbar'

export function computeCollapseOrder(items: OverflowToolbarItem[]): number[] {
  const collapsible: { index: number; priority: number }[] = []
  items.forEach((item, index) => {
    if (!item.pinned) {
      collapsible.push({
        index,
        priority: item.priority ?? 0,
      })
    }
  })
  collapsible.sort((a, b) => {
    if (a.priority !== b.priority) {
      return a.priority - b.priority
    }
    return b.index - a.index
  })
  return collapsible.map((c) => c.index)
}

export function planToolbarOverflow(
  widths: number[],
  available: number,
  moreWidth: number,
  gap: number,
  order: number[],
): number[] {
  const n = widths.length
  if (n === 0) return []

  const totalAll = widths.reduce((sum, w) => sum + w, 0) + (n > 0 ? (n - 1) * gap : 0)
  if (totalAll <= available) {
    return []
  }

  const hidden: number[] = []
  const hiddenSet = new Set<number>()

  for (const idx of order) {
    hidden.push(idx)
    hiddenSet.add(idx)

    const visibleWidths: number[] = []
    for (let i = 0; i < n; i++) {
      if (!hiddenSet.has(i)) {
        visibleWidths.push(widths[i])
      }
    }

    const visCount = visibleWidths.length
    const totalNeeded =
      visCount > 0
        ? visibleWidths.reduce((sum, w) => sum + w, 0) + (visCount - 1) * gap + gap + moreWidth
        : moreWidth

    if (totalNeeded <= available) {
      return hidden
    }
  }

  return hidden
}
